import _ from "lodash"
import { t } from "i18next"
import TitleModal from "../common/titleModal"
import BoxPrenotationLink from "./boxPrenotationLink"
import ButtonSubmit from "../common/buttonSubmit"
import { getAxiosTranslatedError, hasModules } from "../../utils/helpers"
import { useSelector } from "react-redux"
import { useDoctorToken } from "../../hooks/useMeeting"
import AlertMessage from "../alertMessage"
import { useEffect, useState } from "react"

const BoxPrenotationLinks = (props: any) => {
  const { user } = useSelector((state: any) => state.login);
  let prenotations = props.prenotations || []
  let isReservation = props.hasReservation || false
  const timeslot = props.timeslot

  const closingTime = new Date(timeslot.closingTime).getTime()
  const isMeetingPassed = (!isNaN(closingTime) && Date.now() > closingTime)

  const [startVisitError, setStartVisitError] = useState('')

  useEffect(() => {
    setStartVisitError('')
  }, [timeslot])

  const { mutate: doctorToken, isPending: doctorTokenIsPending } = useDoctorToken()

  function handleStartVisit() {
    const bookingId = _.get(prenotations, '0._id')
    if (!bookingId) {
      console.error('no prenotation found')
    }

    doctorToken({ bookingId },
      {
        onSuccess: ({ token }: any) => {
          window.open(`/telemedicine/doctor/${token}`)
        },
        onError: (error) => {
          setStartVisitError(getAxiosTranslatedError(error))
        },
      }
    )
  }

  return (
    <>
      {((prenotations.length) ?
        <div className="footer">

          <div className="col-12 mt-4">
            <TitleModal title={t('reservations')} />

            <div className="boxPrenotationLinks">
              {prenotations.map((prenotation: any, index: any) =>
                <BoxPrenotationLink handleClick={() => { props.clickPrenotationLink(prenotation?._id) }} key={index} prenotation={prenotation} />
              )
              }

            </div>
          </div>
          {
            hasModules(user, 'FEDERFARMA_DOCTOR') && isReservation &&
            <>
              <div className="col-lg-12 p-1">
                <ButtonSubmit
                  disabled={isMeetingPassed}
                  handleChange={handleStartVisit}
                  textButton={isMeetingPassed ? t('prenotation.finished-visit') : t('prenotation.start-visit')}
                />
              </div>
              {startVisitError && <div className="col-lg-12 p-2">
                <AlertMessage description={startVisitError}
                  additionalClass="mt-2" />
              </div>}
            </>
          }

        </div>
        :
        <></>
      )}
    </>


  )
}

export default BoxPrenotationLinks;
